module.exports = __webpack_public_path__ + "static/media/authBg.377fa91b.png";